// Custom feedback tab. PostHog's survey is configured with "Feedback button
// type: Custom" pointing at the #feedback-button selector below, so PostHog no
// longer draws its own tab — it just opens the survey when this button is
// clicked. That lets us control the position (the dashboard only offers a 9
// point anchor grid; we want it ~80% down the right edge, out of the way of
// fixture content). See App.js where this is rendered globally.
const FeedbackButton = () => {
    return (
        <button
            id="feedback-button"
            type="button"
            className="sk-feedback-tab"
            aria-label="Send feedback"
        >
            Feedback
        </button>
    );
};

export default FeedbackButton;
